/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trust_Soc2Inputs */



/**
* | output |
* | --- |
* | "SOC 2 Type II Certified" |
*
* @param {Pricing_Trust_Soc2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_trust_soc2 = /** @type {((inputs?: Pricing_Trust_Soc2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trust_Soc2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SOC 2 Typ II zertifiziert")
	return /** @type {LocalizedString} */ ("SOC 2 Type II Certified")
});